import { forwardRef } from 'react'
import { fieldBaseStyle, fieldLabelStyle } from './Input'
import type { TextareaHTMLAttributes } from 'react'

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  function Textarea({ label, style, rows = 4, ...rest }, ref) {
    const field = (
      <textarea
        ref={ref}
        rows={rows}
        style={{ ...fieldBaseStyle, resize: 'vertical', ...style }}
        {...rest}
      />
    )
    if (!label) return field
    return (
      <label style={{ display: 'block' }}>
        <span style={fieldLabelStyle}>{label}</span>
        {field}
      </label>
    )
  },
)

export default Textarea
